/* THUNDER HONEY V3 cart, Shopify theme only: the header cart count, the cart drawer (snippets/th-v3-cart-drawer.liquid)
   and the full cart page (sections/th-v3-cart.liquid). Shopify AJAX cart API only: /cart.js, /cart/add.js, /cart/change.js.

   Welcome kit rule, the same as the live theme: the kit (Glass Bottle + Metal Scooper) is a subscription gift. A cart with a
   subscription line carries exactly one kit, which the store's automatic discount "Subscription free product" makes 0 kr.
   A cart without a subscription carries no free kit. Every change runs through normalize(), which keeps the cart in that state.

   Paid starter kit (7 Oct 2026, Joakim): a one-time cart can ADD the same kit as a paid extra. Never pre-chosen: the drawer and
   the cart page show a prompt card ("Add the starter kit?") while the cart has a one-time Daylight line, no subscription line
   and no kit. Its button adds the kit with the hidden line property _th_addon=1, so it is a line of its own beside the free
   subscription kit (a line without the property). Its quieter link switches the one-time line to the 90-day plan (3 pouches,
   or more if the line had more): one add.js request puts in the free kit and then the 90-day line, the same order add() uses so
   Daylight leads the checkout order summary, and only then does the one-time line go. normalize() keeps the paid kit only in a
   cart without a subscription that still has a one-time Daylight line, at quantity 1; a subscriber gets the free kit instead,
   so a cart never ends with only a kit in it. The paid kit line has no stepper, only Remove, and shows its own price.

   API: window.THCart.add({ plan: 'p90' | 'p30' | 'once' }) or .add({ id, quantity, selling_plan }), .open(), .close(),
   .refresh(), .plans, .cart. Events on document: th:cart:updated (detail: cart), th:cart:open, th:cart:close.

   Swedish: when the drawer's config carries data-lang="sv" (snippets/th-v3-cart-drawer on a template whose suffix contains
   sv), every word below comes from T.sv, the two Daylight plans show their Swedish names and kronor are written with a
   space for the thousands (1 497 kr), Daylight lines link to the Swedish product view (data-pdp) and the product photos
   have Swedish alt text. Without it nothing changes: T.en holds the English words exactly as before.
   Chat: while the drawer is open (html.th-cd-open) th-v3-cart.css hides the Tidio chat launcher, which otherwise sits on
   top of the Checkout button on a phone; it comes back when the drawer closes. */
(function () {
  'use strict';
  var d = document, w = window, html = d.documentElement;
  if (w.THCart) return;

  var drawer = d.getElementById('th-cd');
  var panel = drawer ? drawer.querySelector('[data-cv]') : null;
  var pageEl = d.querySelector('[data-th-cart-page]');
  var cfgEl = d.querySelector('[data-th-cart-cfg]');
  var TH = w.TH_V3 || {};
  function attr(k, def) { var v = cfgEl ? cfgEl.getAttribute('data-' + k) : null; return v == null || v === '' ? def : v; }
  function int(k, def) { var n = parseInt(attr(k, ''), 10); return isFinite(n) ? n : def; }
  var ROOT = attr('root', TH.root || '/'); if (ROOT.slice(-1) !== '/') ROOT += '/';
  var CFG = {
    variant: int('variant', 53602424848726),
    p90: int('p90', 691094716758),
    p30: int('p30', 691094749526),
    p90Qty: int('p90-qty', 3),
    gift: int('gift', 50424597840214),
    giftValue: int('gift-value', 22800),
    kitPrice: int('kit-price', int('gift-value', 22800)),
    kitBottle: attr('kit-bottle', ''),
    kitScoop: attr('kit-scoop', ''),
    giftImg: attr('gift-img', ''),
    pouchImg: attr('pouch-img', ''),
    oncePrice: int('once-price', 64900),
    p30Price: int('p30-price', 54900),
    p90Price: int('p90-price', 49900),
    ref: int('ref', 74900),
    pdp: attr('pdp', TH.pdp || '/products/thunderhoney-daylight'),
    money: attr('money-format', '{{amount_no_decimals}} kr')
  };
  var SV = attr('lang', '') === 'sv';
  var T = SV ? {
    err: function (st) { return 'Varukorgen kunde inte uppdateras (' + st + ').'; },
    retry: 'Varukorgen kunde inte uppdateras. Försök igen.',
    kit: 'Välkomstkit', kitAlt: 'Välkomstkitet, en glasflaska och en metallskopa', kitSub: 'Glasflaska + metallskopa',
    pouchAlt: 'Påsen Thunder Honey Daylight, silverfolie med marinblå logotyp',
    once: 'Engångsköp', p90: '90-dagarsplan', p30: '30-dagarsplan',
    kitFree: 'Gratis med din prenumeration', save: function (n) { return 'Spara ' + n + '\u00a0%'; }, free: 'Gratis',
    qty: 'Antal', less: 'En mindre', lessMin: function (n) { return 'En mindre (90-dagarsplanen är minst ' + n + ' påsar)'; },
    more: 'En till', rm: 'Ta bort', was: 'Ordinarie pris ',
    addon: 'Välkomstkit', addonSub: 'Glasflaska + metallskopa', addonAlt: 'Välkomstkitet, en glasflaska och en metallskopa',
    kpH: 'Vill du lägga till välkomstkitet?', kpP: 'Glasflaska + metallskopa',
    kpB: function (p) { return 'Lägg till · ' + p; }, kpBL: function (p) { return 'Lägg till välkomstkitet för ' + p; },
    kpS: function (p) { return 'Eller prenumerera från <span class="th-up__nw">' + p + '/mån</span> och få det på köpet'; },
    items: function (n) { return n + (n === 1 ? ' vara' : ' varor'); },
    disc: 'Rabatt', cart: 'Varukorg'
  } : {
    err: function (st) { return 'The cart could not be updated (' + st + ').'; },
    retry: 'The cart could not be updated. Please try again.',
    kit: 'Welcome kit', kitAlt: 'The welcome kit, a glass bottle and a metal scooper', kitSub: 'Glass bottle + metal scooper',
    once: 'One-time purchase', p90: '', p30: '',
    kitFree: 'Free with your subscription', save: function (n) { return 'Save ' + n + '%'; }, free: 'Free',
    qty: 'Quantity', less: 'One less', lessMin: function (n) { return 'One less (the 90-day plan is at least ' + n + ' pouches)'; },
    more: 'One more', rm: 'Remove', was: 'Regular price ',
    addon: 'Welcome kit', addonSub: 'Glass bottle + metal scooper', addonAlt: 'The welcome kit, a glass bottle and a metal scooper',
    kpH: 'Add the welcome kit?', kpP: 'Glass bottle + metal scooper',
    kpB: function (p) { return 'Add · ' + p; }, kpBL: function (p) { return 'Add the welcome kit for ' + p; },
    kpS: function (p) { return 'Or subscribe from <span class="th-up__nw">' + p + '/mo</span> and get it free'; },
    items: function (n) { return n + (n === 1 ? ' item' : ' items'); },
    disc: 'Discount', cart: 'Cart'
  };
  function noop() {}

  /* ---------- money, in the store's own format (the same output as Liquid's money filter) ---------- */
  function money(cents) {
    cents = Math.round(+cents || 0);
    var m = CFG.money.match(/\{\{\s*(\w+)\s*\}\}/);
    function fmt(dec, th, de) {
      var s = (cents / 100).toFixed(dec).split('.');
      return s[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th) + (s[1] ? de + s[1] : '');
    }
    var v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = fmt(0, SV ? '\u00a0' : ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(0, ' ', ''); break;
      case 'amount_with_space_separator': v = fmt(2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = fmt(2, ' ', '.'); break;
      default: v = fmt(2, ',', '.');
    }
    return m ? CFG.money.replace(m[0], v) : v;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function sized(u, px) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + px : ''; }

  /* ---------- the AJAX cart API, one request at a time ---------- */
  function api(path, body) {
    var opt = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (body) { opt.method = 'POST'; opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
    else opt.cache = 'no-store';
    return fetch(ROOT + path, opt).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var e = new Error((j && (j.description || j.message)) || T.err(r.status));
          e.status = r.status; throw e;
        }
        return j;
      });
    });
  }
  function getCart() { return api('cart.js'); }
  var chain = Promise.resolve();
  function serial(fn) { var p = chain.then(fn); chain = p.then(noop, noop); return p; }

  /* ---------- the welcome kit rule ---------- */
  /* isKit: any kit line; isAddon: the paid starter kit (hidden property _th_addon); isGift: the free subscription kit */
  function isKit(i) { return i.variant_id === CFG.gift; }
  function isAddon(i) { return isKit(i) && !!(i.properties && i.properties._th_addon); }
  function isGift(i) { return isKit(i) && !isAddon(i); }
  function isSub(i) { return !!i.selling_plan_allocation; }
  function planOf(i) { return i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan : null; }
  function isDaylight(i) { return i.variant_id === CFG.variant || i.handle === 'thunderhoney-daylight'; }
  function isOnceDaylight(i) { return isDaylight(i) && !isSub(i) && !isKit(i); }
  function minQty(i) { var p = planOf(i); return p && (p.id === CFG.p90 || /90/.test(p.name || '')) ? CFG.p90Qty : 1; }
  var giftFailed = false;
  function normalize(cart, n) {
    n = n || 0;
    if (!cart || !cart.items || n > 5) return Promise.resolve(cart);
    var hasSub = cart.items.some(isSub), gifts = cart.items.filter(isGift), addons = cart.items.filter(isAddon), step = null;
    /* the paid starter kit first: it goes when a subscription brings the free kit, or when no one-time Daylight line is left
       (a cart never ends with only a kit); otherwise one line at quantity 1 */
    if (addons.length && (hasSub || !cart.items.some(isOnceDaylight))) step = api('cart/change.js', { id: addons[0].key, quantity: 0 });
    else if (addons.length > 1) step = api('cart/change.js', { id: addons[addons.length - 1].key, quantity: 0 });
    else if (addons.length === 1 && addons[0].quantity !== 1) step = api('cart/change.js', { id: addons[0].key, quantity: 1 });
    /* the free subscription kit, exactly as before */
    else if (!hasSub && gifts.length) step = api('cart/change.js', { id: gifts[0].key, quantity: 0 });
    else if (hasSub && gifts.length > 1) step = api('cart/change.js', { id: gifts[gifts.length - 1].key, quantity: 0 });
    else if (hasSub && gifts.length === 1 && gifts[0].quantity !== 1) step = api('cart/change.js', { id: gifts[0].key, quantity: 1 });
    else if (hasSub && !gifts.length && !giftFailed) {
      step = api('cart/add.js', { items: [{ id: CFG.gift, quantity: 1 }] }).then(getCart, function () { giftFailed = true; return null; });
    }
    if (!step) return Promise.resolve(cart);
    return step.then(function (c) { return c && c.items ? normalize(c, n + 1) : cart; }, function () { return cart; });
  }

  /* ---------- markup (sections/th-v3-cart.liquid renders the same markup in Liquid) ---------- */
  function lineHTML(i, keepSrc) {
    var gift = isGift(i), addon = isAddon(i), kit = gift || addon, plan = planOf(i), spa = i.selling_plan_allocation, min = minQty(i);
    var url = i.url || CFG.pdp;
    var title = gift ? T.kit : addon ? T.addon : i.product_title;
    var alt = gift ? T.kitAlt : addon ? T.addonAlt : ((i.featured_image && i.featured_image.alt) || i.product_title);
    /* Swedish: Daylight links open the Swedish product view (CFG.pdp: ?view=figma-sv, or the Swedish view the drawer is on), and
       the alt text is Swedish (the store's alt texts are English): the pouch photo by its Swedish description, any other product
       by its name. sections/th-v3-cart.liquid does the same. */
    if (SV && !kit) {
      if (isDaylight(i)) url = CFG.pdp;
      alt = i.variant_id === CFG.variant && CFG.pouchImg ? T.pouchAlt : i.product_title;
    }
    var sub = gift ? T.kitSub : addon ? T.addonSub : plan ? plan.name : (i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : T.once);
    /* Swedish: the two Daylight plans by their Swedish names (the store's plan names are English), other plans as named */
    if (SV && plan && !kit) {
      if (plan.id === CFG.p90 || /90/.test(plan.name || '')) sub = T.p90;
      else if (plan.id === CFG.p30 || /30/.test(plan.name || '')) sub = T.p30;
    }
    /* the crossed-out reference: 749 kr on every Daylight option, as in the product page buy box (th_ref in
       sections/th-v3-pdp-buy.liquid), or the plan's or the variant's compare-at if higher; other lines keep their own */
    var unit = spa ? spa.price : (i.original_price != null ? i.original_price : i.price);
    var ref = spa && spa.compare_at_price > spa.price ? spa.compare_at_price : 0;
    if (!kit && isDaylight(i) && CFG.ref > ref) ref = CFG.ref;
    var tags = '';
    if (gift && i.final_line_price === 0) tags += '<span class="th-ci__tag th-ci__tag--ice">' + T.kitFree + '</span>';
    if (!gift && ref > unit) tags += '<span class="th-ci__tag">' + T.save(Math.round((ref - unit) * 100 / ref)) + '</span>';
    if (!gift) (i.line_level_discount_allocations || []).forEach(function (a) {
      var t = a.discount_application && a.discount_application.title;
      if (t && a.amount > 0) tags += '<span class="th-ci__tag th-ci__tag--disc">' + esc(t) + ' &minus;' + esc(money(a.amount)) + '</span>';
    });
    var was = ref > unit ? ref * i.quantity : 0;
    if (i.original_line_price > was) was = i.original_line_price;
    /* the paid starter kit always shows its own price in money, never the word Free */
    var now = gift && i.final_line_price === 0 ? T.free : money(i.final_line_price);
    var ctl = '';
    if (addon) ctl = '<div class="th-ci__ctl"><button type="button" class="th-ci__rm" data-rm>' + T.rm + '</button></div>';
    else if (!gift) {
      var atMin = i.quantity <= min;
      ctl = '<div class="th-ci__ctl"><div class="th-qty" role="group" aria-label="' + T.qty + '">' +
        '<button type="button" class="th-qty__b" data-q="-1" aria-label="' + (min > 1 && atMin ? T.lessMin(min) : T.less) + '"' + (atMin ? ' disabled' : '') + '>&minus;</button>' +
        '<span class="th-qty__n">' + i.quantity + '</span>' +
        '<button type="button" class="th-qty__b" data-q="1" aria-label="' + T.more + '">+</button></div>' +
        '<button type="button" class="th-ci__rm" data-rm>' + T.rm + '</button></div>';
    }
    /* theme photos instead of the store images: the kit shows the kit alone, no pouch (th-v3-cart-kit-thumb.webp, from the
       buy box's pdp-a/kit-bottle-320), and Daylight the cleared pouch (th-v3-cart-pouch-thumb.webp, from pdp-hero), because the admin
       featured image still prints a caffeine claim we may not make */
    var src = kit && CFG.giftImg ? CFG.giftImg : (i.variant_id === CFG.variant && CFG.pouchImg ? CFG.pouchImg : (i.image ? (keepSrc || sized(i.image, 240)) : ''));
    var img = src ? '<img src="' + esc(src) + '" alt="' + esc(alt) + '" width="120" height="120" decoding="async">' : '';
    return '<li class="th-ci' + (gift ? ' th-ci--gift' : addon ? ' th-ci--addon' : '') + '" data-key="' + esc(i.key) + '" data-qty="' + i.quantity + '" data-min="' + min + '">' +
      (kit ? '<span class="th-ci__media">' + img + '</span>' : '<a class="th-ci__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>') +
      '<div class="th-ci__main"><p class="th-ci__t">' + (kit ? esc(title) : '<a href="' + esc(url) + '">' + esc(title) + '</a>') + '</p>' +
      '<p class="th-ci__s">' + esc(sub) + '</p>' + (tags ? '<p class="th-ci__tags">' + tags + '</p>' : '') + ctl + '</div>' +
      '<p class="th-ci__p">' + (was > i.final_line_price ? '<s class="th-ci__was"><span class="th-sr">' + T.was + '</span>' + esc(money(was)) + '</s>' : '') +
      '<b class="th-ci__now">' + esc(now) + '</b></p></li>';
  }
  /* the starter kit prompt (replaces the 30-day nudge of one-time carts): only while the cart has a one-time Daylight line,
     no subscription line and no kit. Add puts the paid kit in; the link moves that line to the 90-day plan (at least 3 pouches)
     with the free kit, through subscribe(). The price on the button is the kit variant's own price (data-kit-price, from Liquid). */
  function upHTML(cart) {
    var line = null;
    cart.items.some(function (i) { if (isOnceDaylight(i)) { line = i; return true; } return false; });
    if (!line || cart.items.some(isSub) || cart.items.some(isKit)) return '';
    var kp = esc(money(CFG.kitPrice)), ph = '';
    if (CFG.kitBottle) ph += '<span class="th-up__ph"><img src="' + esc(CFG.kitBottle) + '" alt="" width="320" height="400" decoding="async"></span>';
    if (CFG.kitScoop) ph += '<span class="th-up__ph th-up__ph--scoop"><img src="' + esc(CFG.kitScoop) + '" alt="" width="320" height="400" decoding="async"></span>';
    return (ph ? '<span class="th-up__media" aria-hidden="true">' + ph + '</span>' : '') +
      '<div class="th-up__main"><p class="th-up__h">' + T.kpH + '</p><p class="th-up__p">' + T.kpP + '</p>' +
      '<button type="button" class="btn btn--navy btn--sm th-up__b" data-kit-add aria-label="' + esc(T.kpBL(money(CFG.kitPrice))) + '">' + T.kpB(kp) + '</button>' +
      '<button type="button" class="th-up__s" data-kit-sub="' + esc(line.key) + '">' + T.kpS(esc(money(CFG.p90Price))) + '</button></div>';
  }

  /* ---------- a view: the drawer panel or the cart page ---------- */
  function View(el) {
    var v = this;
    function q(s) { return el.querySelector('[data-cv-' + s + ']'); }
    this.el = el; this.list = q('list'); this.up = q('up'); this.empty = q('empty'); this.ft = q('ft'); this.total = q('total');
    this.disc = q('disc'); this.discL = q('disc-l'); this.discV = q('disc-v'); this.n = q('n'); this.msg = q('msg'); this.loading = q('loading');
    el.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-q],[data-rm],[data-kit-add],[data-kit-sub]') : null;
      if (!b || b.disabled || !el.contains(b)) return;
      e.preventDefault();
      /* the starter kit prompt: Add puts the paid kit in (its own line, hidden property _th_addon); the link moves the
         one-time line to the 90-day plan with the free kit (subscribe()). Focus then goes to what replaced the prompt. */
      if (b.hasAttribute('data-kit-add')) {
        b.disabled = true;
        run(function () { return api('cart/add.js', { items: [{ id: CFG.gift, quantity: 1, properties: { _th_addon: '1' } }] }).then(getCart); })
          .then(function () { v.refocus('.th-ci--addon [data-rm]'); }, noop);
        return;
      }
      if (b.hasAttribute('data-kit-sub')) {
        b.disabled = true;
        subscribe(b.getAttribute('data-kit-sub')).then(function () { v.refocus('.th-ci__t a'); }, noop);
        return;
      }
      var li = b.closest('[data-key]'); if (!li) return;
      var key = li.getAttribute('data-key'), qty = parseInt(li.getAttribute('data-qty'), 10) || 0, min = parseInt(li.getAttribute('data-min'), 10) || 1;
      if (b.hasAttribute('data-rm')) { update({ id: key, quantity: 0 }, b); return; }
      var nq = qty + parseInt(b.getAttribute('data-q'), 10);
      if (nq > 0 && nq < min) return;
      update({ id: key, quantity: Math.max(0, nq) }, b);
    });
    v.rendered = false;
  }
  /* after the prompt is replaced, keep the keyboard where it was: on the new element, or on the drawer panel */
  View.prototype.refocus = function (sel) {
    var a = d.activeElement;
    if (a && a !== d.body && this.el.contains(a)) return;
    var t = this.el.querySelector(sel) || (this.el.hasAttribute('tabindex') ? this.el : null);
    if (t) { try { t.focus({ preventScroll: true }); } catch (e) {} }
  };
  View.prototype.busy = function (on) { this.el.classList.toggle('is-busy', !!on); this.el.setAttribute('aria-busy', on ? 'true' : 'false'); };
  View.prototype.say = function (t) { if (this.msg) { this.msg.textContent = t || ''; this.msg.hidden = !t; } };
  View.prototype.render = function (cart) {
    var items = cart.items || [];
    if (this.loading) this.loading.hidden = true;
    this.rendered = true;
    if (this.n) this.n.textContent = cart.item_count ? T.items(cart.item_count) : '';
    if (!items.length) {
      if (this.list) this.list.innerHTML = '';
      if (this.up) { this.up.innerHTML = ''; this.up.hidden = true; }
      if (this.empty) this.empty.hidden = false;
      if (this.ft) this.ft.hidden = true;
      this.el.classList.add('is-empty');
      return;
    }
    this.el.classList.remove('is-empty');
    if (this.empty) this.empty.hidden = true;
    if (this.ft) this.ft.hidden = false;
    /* paid lines first, the kit last (the paid starter kit too) */
    var ordered = items.filter(function (i) { return !isKit(i); }).concat(items.filter(isKit));
    /* keep the image URL a line already shows (the cart page renders it in Liquid first), so nothing reloads */
    var keep = {};
    if (this.list) [].forEach.call(this.list.querySelectorAll('[data-key]'), function (li) { var im = li.querySelector('img'); if (im) keep[li.getAttribute('data-key')] = im.getAttribute('src'); });
    if (this.list) this.list.innerHTML = ordered.map(function (i) { return lineHTML(i, keep[i.key]); }).join('');
    if (this.up) { var u = upHTML(cart); this.up.innerHTML = u; this.up.hidden = !u; }
    var giftDisc = 0, titles = [];
    items.forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (a) {
        if (isGift(i)) { giftDisc += a.amount || 0; return; }
        var t = a.discount_application && a.discount_application.title;
        if (t && titles.indexOf(t) < 0) titles.push(t);
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) { if (a.title && titles.indexOf(a.title) < 0) titles.push(a.title); });
    var disc = (cart.total_discount || 0) - giftDisc;
    if (this.disc) {
      this.disc.hidden = !(disc > 0);
      if (disc > 0) { this.discL.textContent = T.disc + (titles.length ? ' (' + titles.join(', ') + ')' : ''); this.discV.innerHTML = '&minus;' + esc(money(disc)); }
    }
    if (this.total) this.total.textContent = money(cart.total_price);
  };

  var views = [], current = null;
  if (panel) views.push(new View(panel));
  var pageView = pageEl ? new View(pageEl) : null;
  if (pageView) views.push(pageView);

  function emit(name, detail) { try { d.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {} }
  function updateCount(cart) {
    var n = cart.item_count || 0;
    [].forEach.call(d.querySelectorAll('[data-th-cart-count]'), function (el) { el.textContent = n; el.hidden = n === 0; });
    [].forEach.call(d.querySelectorAll('.th-cart[data-th-cart-open]'), function (a) { a.setAttribute('aria-label', n ? T.cart + ', ' + T.items(n) : T.cart); });
  }
  function setCart(cart) {
    if (!cart || !cart.items) return cart;
    current = cart;
    views.forEach(function (v) { v.render(cart); });
    updateCount(cart);
    emit('th:cart:updated', cart);
    return cart;
  }
  function busy(on) { views.forEach(function (v) { v.busy(on); }); }
  function say(t) { views.forEach(function (v) { v.say(t); }); }

  /* run one cart operation: request, keep the kit rule, render everywhere */
  function run(fn, quiet) {
    if (!quiet) { busy(true); say(''); }
    return serial(function () { return fn().then(function (c) { return normalize(c); }); })
      .then(function (c) { setCart(c); busy(false); return c; }, function (e) {
        busy(false); say(e && e.message ? e.message : T.retry);
        return serial(function () { return getCart().then(function (c) { return normalize(c); }); }).then(setCart, noop).then(function () { throw e; });
      });
  }
  function update(body, btn) {
    if (btn) btn.disabled = true;
    return run(function () { return api('cart/change.js', body); }).catch(noop);
  }
  function refresh() { return run(getCart, !!current).catch(noop); }

  /* the prompt's subscribe link: the one-time line (key) becomes a 90-day line of max(3, its quantity), same variant, same
     line properties. A plan change through change.js would leave normalize() to add the kit afterwards as the newest line,
     above Daylight in the checkout order summary. So, like add(): one add.js request with the kit first and the 90-day line
     last (Shopify lists the newest line first), and only after it succeeds is the one-time line removed. A failed add never
     costs the customer the pouch already in the cart. Decided on the live cart, not the cached one. */
  function subscribe(key) {
    return run(function () {
      return getCart().catch(function () { return current; }).then(function (c) {
        var line = null;
        if (c && c.items) c.items.some(function (i) { if (i.key === key && isOnceDaylight(i)) { line = i; return true; } return false; });
        if (!line) return c && c.items ? c : getCart();   /* the line changed elsewhere: just show the cart as it is */
        var it = { id: line.variant_id, quantity: Math.max(CFG.p90Qty, line.quantity), selling_plan: CFG.p90 };
        if (line.properties && Object.keys(line.properties).length) it.properties = line.properties;
        var withGift = !c.items.some(isGift);
        return api('cart/add.js', { items: withGift ? [{ id: CFG.gift, quantity: 1 }, it] : [it] })
          .catch(function (e) {
            if (!withGift || e.status !== 422) throw e;
            return api('cart/add.js', { items: [it] });   /* the plan alone; normalize tries the kit once more */
          })
          .then(function () { return api('cart/change.js', { id: key, quantity: 0 }); });
      });
    }).catch(noop);
  }

  /* add to cart: the product with its plan, the kit with a subscription, then the drawer */
  function add(o) {
    o = o || {};
    var items;
    if (o.items && o.items.length) items = o.items.slice();
    else {
      var sp = o.selling_plan != null ? +o.selling_plan || null : o.plan === 'p90' ? CFG.p90 : o.plan === 'p30' ? CFG.p30 : null;
      var it = { id: +o.id || CFG.variant, quantity: +o.quantity || (sp && sp === CFG.p90 ? CFG.p90Qty : 1) };
      if (sp) it.selling_plan = sp;
      items = [it];
    }
    var sub = items.some(function (x) { return !!x.selling_plan; });
    var giftAsked = items.some(function (x) { return +x.id === CFG.gift; });
    if (drawer && o.open !== false) open(true);
    return run(function () {
      /* decide on the kit from the live cart, not the cached one: a cart emptied in another tab or at /cart/clear would
         otherwise get the product alone, normalize would add the kit afterwards and the kit would lead the order summary */
      return getCart().catch(function () { return current; }).then(function (c) {
        var withGift = sub && !giftAsked && !(c && c.items && c.items.some(isGift));
        /* the kit goes first: Shopify lists the newest line first, so Daylight leads the checkout order summary */
        return api('cart/add.js', { items: withGift ? [{ id: CFG.gift, quantity: 1 }].concat(items) : items })
          .catch(function (e) {
            if (!withGift || e.status !== 422) throw e;
            return api('cart/add.js', { items: items });   /* the product alone; normalize tries the kit once more */
          });
      }).then(getCart);
    });
  }

  /* ---------- the cookie banner and the drawer ----------
     The consent banner (#thcb, snippets/th-consent-banner) sits above everything. Where it overlaps the drawer panel (a phone,
     or the bottom right corner on a desktop page), the panel ends just above it through --th-cd-ck, so a first visit sees
     Checkout and both banner buttons together. Once the banner is answered it hides itself and the panel goes back down. */
  var ckEl = null, ckRO = null, ckMO = null;
  function ckLift() {
    var b = d.getElementById('thcb'), h = 0;
    if (b && b !== ckEl) {
      ckEl = b;
      if (ckRO) ckRO.disconnect(); if (ckMO) ckMO.disconnect();
      if ('ResizeObserver' in w) { ckRO = new ResizeObserver(ckLift); ckRO.observe(b); }
      ckMO = new MutationObserver(ckLift); ckMO.observe(b, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    }
    if (b && panel && b.getClientRects().length) {
      var r = b.getBoundingClientRect(), pl = panel.offsetLeft, pr = pl + panel.offsetWidth;
      if (r.height && r.left < pr && r.right > pl) h = Math.min(Math.max(0, Math.round(innerHeight - r.top)), Math.round(innerHeight * 0.6));
    }
    html.style.setProperty('--th-cd-ck', h + 'px');
  }
  if (drawer && panel) {
    ckLift();
    w.addEventListener('resize', ckLift);
    d.addEventListener('th:cart:open', ckLift);
    if (!ckEl) d.addEventListener('DOMContentLoaded', ckLift);
  }

  /* ---------- the drawer: open, close, focus ---------- */
  var lastFocus = null;
  function isOpen() { return html.classList.contains('th-cd-open'); }
  function open(skipRefresh) {
    if (!drawer) { w.location.href = ROOT + 'cart'; return; }
    if (html.classList.contains('th-menu-open')) { var bg = d.querySelector('.th-burger'); if (bg) bg.click(); }
    if (!isOpen()) {
      lastFocus = d.activeElement;
      html.classList.add('th-cd-open');
      drawer.removeAttribute('inert'); drawer.setAttribute('aria-hidden', 'false');
      setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); } }, 40);
      emit('th:cart:open');
    }
    if (current) views[0].render(current);
    if (skipRefresh !== true) refresh();
  }
  function close() {
    if (!drawer || !isOpen()) return;
    html.classList.remove('th-cd-open');
    drawer.setAttribute('inert', ''); drawer.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus && d.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    emit('th:cart:close');
  }
  d.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-th-cart-open],[data-th-cd-close]') : null;
    if (!t) return;
    if (t.hasAttribute('data-th-cd-close')) { e.preventDefault(); close(); return; }
    if (!drawer || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;   /* no drawer here: the link opens the cart page */
    e.preventDefault(); open();
  });
  d.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = [].slice.call(panel.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'))
      .filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) { e.preventDefault(); return; }
    var i = f.indexOf(d.activeElement);
    if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && (i < 0 || i === f.length - 1)) { e.preventDefault(); f[0].focus(); }
  });

  /* ---------- start ---------- */
  /* the cart page arrives rendered in Liquid; read the live cart and apply the kit rule (for example after a /cart/add?... link) */
  if (pageView) run(getCart, true).catch(noop);
  w.addEventListener('pageshow', function (e) { if (e.persisted) run(getCart, true).catch(noop); });

  w.thCartDrawerOpen = w.thCartDrawerOpen || function () { open(); };
  w.thCartOpenAfterAdd = w.thCartOpenAfterAdd || function (btn, label) {
    if (btn) { btn.dataset.busy = ''; btn.textContent = label; btn.style.opacity = '1'; }
    open();
  };
  w.THCart = {
    add: add, open: open, close: close, refresh: refresh, money: money,
    plans: { variant: CFG.variant, p90: CFG.p90, p30: CFG.p30, gift: CFG.gift, p90Qty: CFG.p90Qty },
    get cart() { return current; }
  };
})();
